import {
  LAMBDATEST_SHARE_LOADING,
  LAMBDATEST_SHARE_SUCCESS,
  LAMBDATEST_SHARE_FAILED,
  LAMBDATEST_SHARE_CLEAR,
} from '../actionTypeConstants/LambdaTestShareConstants';

const initialState = {
  testShareState: {
    loading: false,
    data: null,
    error: null,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_SHARE_LOADING:
      return {
        ...state,
        testShareState: {
          ...state.testShareState,
          loading: true,
          data: null,
          error: null,
        },
      };
    case LAMBDATEST_SHARE_SUCCESS:
      return {
        ...state,
        testShareState: {
          ...state.testShareState,
          loading: false,
          data: action.result.data,
          error: null,
        },
      };
    case LAMBDATEST_SHARE_FAILED:
      return {
        ...state,
        testShareState: {
          ...state.testShareState,
          loading: false,
          error: action.error.response,
          data: null,
        },
      };
    case LAMBDATEST_SHARE_CLEAR:
      return {
        ...state,
        testShareState: {
          loading: false,
          data: null,
          error: null,
        },
      };
    default:
      return state;
  }
}
